import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { Grid, Paper } from '../../../../../components/mui/Core/index'
import { getNumberValueFormat } from '../../../../../utils/string-utils'
import Constants from '../../../../../constants/en.json'

export function ItemCodeSummaryTable() {
  const itemCodeSummary = useSelector((state) => state.itemCode.itemCodeSummary)
  const isFetchingItemCodeSummary = useSelector((state) => state.itemCode.isFetchingItemCodeSummary)
  const rows = itemCodeSummary.map((row) => ({
    id: row.itemCode,
    itemCode: row.itemCode,
    uom: row.uom,
    quantity: row.quantity,
  }))

  const columns = [
    {
      field: 'itemCode',
      headerName: Constants.inventory.ITEM_CODE,
      sortable: false,
      flex: 0.5,
      minWidth: 150,
    },
    {
      field: 'quantity',
      headerName: Constants.inventory.TOTAL_QTY,
      sortable: false,
      headerAlign: 'right',
      align: 'right',
      valueFormatter: (value) => {
        return getNumberValueFormat(value)
      },
      flex: 1,
      minWidth: 100,
    },
    {
      field: 'uom',
      headerName: Constants.inventory.UOM,
      sortable: false,
      minWidth: 100,
    },
  ]

  const itemCodeSummaryTableStyle = {
    backgroundColor: 'white',
    minHeight: '160px',
    height: isFetchingItemCodeSummary ? '400px' : 'auto',
  }

  return (
    <Grid sx={{ pt: 3 }}>
      <Paper>
        <DataGrid
          sx={itemCodeSummaryTableStyle}
          rows={rows}
          columns={columns}
          loading={isFetchingItemCodeSummary}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
          pageSizeOptions={[25, 50]}
          spacing={1}
          slotProps={{
            pagination: {
              component: 'div',
              showLastButton: true,
              showFirstButton: true,
            },
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
        />
      </Paper>
    </Grid>
  )
}

export default ItemCodeSummaryTable
